/* istanbul ignore file */
import { createScopedInstance, getLanguage } from '@citrite/translate';
import { languages } from '../locales';

export { getLanguage };

export const { t: tmp } = createScopedInstance({
	resources: languages,
	namespace: 'workflows-pilet',
});

export const t: (str: string, opts?: any) => string = tmp;

type Locales = 'en' | 'es' | 'de' | 'fr' | 'it' | 'ja' | 'ko' | 'nl' | 'pt-BR';
export type LocaleString = {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	ko?: string;
	nl?: string;
	'pt-BR'?: string;
};
/**
 * Used to receive correct locale value from a localization string object.
 * Commonly used to evaluate view configuration block/zone parameters
 * Defaults to English
 */
export const getLocaleValue = (localizationObject: LocaleString = {}) => {
	return (localizationObject[getLanguage() as Locales] || localizationObject['en']) ?? '';
};
